export default __webpack_public_path__ + "static/media/base-noise.65079f59.png";